import React from 'react';

import Link from '../link/link';

import './link-list.scss';

export default function LinkList({ items, onClickItem }: Props) {
    return (
        <ul className="link-list">
            {items.map((item, index) => (
                // eslint-disable-next-line react/no-array-index-key
                <li key={index} className="item">
                    <Link
                        {...item}
                        onClick={(e) => onClickItem?.(e, item, index)}
                        title={item?.text}
                    />
                </li>
            ))}
        </ul>
    );
}

interface Props {
    items: { href: string; text: string }[];
    onClickItem?(e: React.MouseEvent, item: Props['items'][0], index: number): void;
}
